/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#selectcolor
 */


class SelectColors {

  static init = (params) => {
    const selSelect = `${params.selSelect}:not(.is-initialized)`;
    const allSelects = document.querySelectorAll(selSelect);

    allSelects.forEach(select => {
      new SelectColors(select);
    })
  }



  constructor(select) {
    this.select = select;
    this.handleChange();
    this.markInitialized();
  }



  markInitialized = () => {
    this.select.classList.add('is-initialized');
  }



  handleChange = () => {
    this.setState();
    this.select.addEventListener("change", () => {
      this.setState(this.select);
    });
  };



  setState = () => {
    this.select.style.color = 'var(--clr-input--placeholder)';
    if (this.selectHasValue()) this.select.style.color = 'var(--clr-input)';
  }



  selectHasValue = () => !!this.select.value;
}